"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The AdresseCreate model module.
 * @module model/AdresseCreate
 * @version 0.0.1
 */
class AdresseCreate {
  /**
   * Constructs a new <code>AdresseCreate</code>.
   * @alias module:model/AdresseCreate
   * @param email {String} 
   * @param phoneNr {String} 
   * @param strasse {String} 
   * @param hausNr {String} 
   * @param plz {String} 
   * @param stadt {String} 
   */
  constructor(email, phoneNr, strasse, hausNr, plz, stadt) {
    AdresseCreate.initialize(this, email, phoneNr, strasse, hausNr, plz, stadt);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, email, phoneNr, strasse, hausNr, plz, stadt) {
    obj['email'] = email;
    obj['phoneNr'] = phoneNr;
    obj['strasse'] = strasse;
    obj['hausNr'] = hausNr;
    obj['plz'] = plz;
    obj['stadt'] = stadt;
  }

  /**
   * Constructs a <code>AdresseCreate</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AdresseCreate} obj Optional instance to populate.
   * @return {module:model/AdresseCreate} The populated <code>AdresseCreate</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AdresseCreate();
      if (data.hasOwnProperty('email')) {
        obj['email'] = _ApiClient.default.convertToType(data['email'], 'String');
      }
      if (data.hasOwnProperty('phoneNr')) {
        obj['phoneNr'] = _ApiClient.default.convertToType(data['phoneNr'], 'String');
      }
      if (data.hasOwnProperty('strasse')) {
        obj['strasse'] = _ApiClient.default.convertToType(data['strasse'], 'String');
      }
      if (data.hasOwnProperty('hausNr')) {
        obj['hausNr'] = _ApiClient.default.convertToType(data['hausNr'], 'String');
      }
      if (data.hasOwnProperty('plz')) {
        obj['plz'] = _ApiClient.default.convertToType(data['plz'], 'String');
      }
      if (data.hasOwnProperty('stadt')) {
        obj['stadt'] = _ApiClient.default.convertToType(data['stadt'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>AdresseCreate</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AdresseCreate</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of AdresseCreate.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
      throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
    }
    // ensure the json data is a string
    if (data['phoneNr'] && !(typeof data['phoneNr'] === 'string' || data['phoneNr'] instanceof String)) {
      throw new Error("Expected the field `phoneNr` to be a primitive type in the JSON string but got " + data['phoneNr']);
    }
    // ensure the json data is a string
    if (data['strasse'] && !(typeof data['strasse'] === 'string' || data['strasse'] instanceof String)) {
      throw new Error("Expected the field `strasse` to be a primitive type in the JSON string but got " + data['strasse']);
    }
    // ensure the json data is a string
    if (data['hausNr'] && !(typeof data['hausNr'] === 'string' || data['hausNr'] instanceof String)) {
      throw new Error("Expected the field `hausNr` to be a primitive type in the JSON string but got " + data['hausNr']);
    }
    // ensure the json data is a string
    if (data['plz'] && !(typeof data['plz'] === 'string' || data['plz'] instanceof String)) {
      throw new Error("Expected the field `plz` to be a primitive type in the JSON string but got " + data['plz']);
    }
    // ensure the json data is a string
    if (data['stadt'] && !(typeof data['stadt'] === 'string' || data['stadt'] instanceof String)) {
      throw new Error("Expected the field `stadt` to be a primitive type in the JSON string but got " + data['stadt']);
    }
    return true;
  }
}
AdresseCreate.RequiredProperties = ["email", "phoneNr", "strasse", "hausNr", "plz", "stadt"];

/**
 * @member {String} email
 */
AdresseCreate.prototype['email'] = undefined;

/**
 * @member {String} phoneNr
 */
AdresseCreate.prototype['phoneNr'] = undefined;

/**
 * @member {String} strasse
 */
AdresseCreate.prototype['strasse'] = undefined;

/**
 * @member {String} hausNr
 */
AdresseCreate.prototype['hausNr'] = undefined;

/**
 * @member {String} plz
 */
AdresseCreate.prototype['plz'] = undefined;

/**
 * @member {String} stadt
 */
AdresseCreate.prototype['stadt'] = undefined;
var _default = exports.default = AdresseCreate;